import {
	MINUTES,
	HOURS,
	DAYS,
	DAYS_24H,
	WEEKS,
	MONTHS,
	TIME_PERIODS,
} from 'common/constants/timePeriods';

export const getTimePeriods = () => {
	return TIME_PERIODS;
};

export const getTimePeriodsMap = () => {
	return {
		MINUTES,
		HOURS,
		DAYS,
		DAYS_24H,
		WEEKS,
		MONTHS,
	};
};

export const getTimeValues = () => {
	// 168 hours in a week
	return Array.from(Array(169).keys()).slice(1);
};
